/**
 * Whether money is worth showing: the brand sells something (its store products), or gives access
 * (codes, guest lists, comps). Null while that is being found out; the products come with the
 * studio, the grants are asked for only when nothing is sold.
 */

import { useEffect, useState } from "react";
import { grants } from "@/api/admin";
import { useStudio } from "@/shell/studio";

export function useMoneyShown(): boolean | null {
  const { client, products } = useStudio();
  const [hasGrants, setHasGrants] = useState<boolean | null>(null);
  const sells = products === null ? null : products.length > 0;

  useEffect(() => {
    if (sells !== false) return;
    let live = true;
    grants.list(client).then((r) => { if (live) setHasGrants(r.grants.length > 0); }).catch(() => { if (live) setHasGrants(false); });
    return () => { live = false; };
  }, [client, sells]);

  return sells === null ? null : sells || hasGrants;
}
